var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMichman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 46,
    viewBox: "0 0 133 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1652_19975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: -1,
    width: 31,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.176 12.9991L109.341 -0.000854492L132.554 38.9991H118.224L102.176 12.9991Z",
    fill: "#00109F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1652_19975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.188 21.8314L47.9697 -53.726",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.932 22.6497L46.7119 -52.9076",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.676 23.4679L45.4561 -52.0912",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.419 24.2845L44.1992 -51.2728",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.162 25.1024L42.9434 -50.455",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.906 25.9207L41.6875 -49.6366",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.649 26.7387L40.4307 -48.8203",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.393 27.555L39.1729 -48.0023",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.136 28.3734L37.916 -47.184",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.879 29.1917L36.6602 -46.3656",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.622 30.0081L35.4033 -45.5492",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.365 30.826L34.1465 -44.7313",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.109 31.6442L32.8906 -43.9131",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.853 32.4627L31.6328 -43.0946",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.596 33.2808L30.376 -42.2782",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.339 34.097L29.1201 -41.4603",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.082 34.9154L27.8633 -40.642",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.826 35.7335L26.6074 -39.8256",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57 36.5501L25.3496 -39.0072",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.313 37.3681L24.0928 -38.1892",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.054 38.1864L22.8359 -37.371",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.798 39.0045L21.5801 -36.5546",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.543 39.8206L20.3242 -35.7367",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.286 40.639L19.0674 -34.9183",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.03 41.4574L17.8096 -34.1",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.774 42.2755L16.5537 -33.2836",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.515 43.0916L15.2969 -32.4657",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.259 43.91L14.041 -31.6473",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.002 44.7283L12.7832 -30.829",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.746 45.5448L11.5264 -30.0126",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.49 46.3631L10.2695 -29.1942",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.233 47.181L9.0127 -28.3763",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.975 47.9991L7.75684 -27.5599",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.718 48.8158L6.5 -26.7416",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.463 49.6337L5.24414 -25.9236",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.206 50.452L3.98633 -25.1053",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.95 51.2701L2.72949 -24.2889",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.692 52.0868L1.47363 -23.4706",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.435 52.9046L0.216797 -22.6527",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.179 53.723L-1.03906 -21.8344",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.924 54.5394L-2.29492 -21.0179",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.666 55.3573L-3.55371 -20.2001",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.411 56.1756L-4.80957 -19.3817",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.152 56.9939L-6.06641 -18.5635",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.895 57.8104L-7.32324 -17.7469",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.639 58.6287L-8.5791 -16.9286",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.382 59.4466L-9.83789 -16.1107",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.126 60.2647L-11.0938 -15.2943",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.869 61.0814L-12.3496 -14.476",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 61.8992L-13.6064 -13.6581",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.356 62.7177L-14.8623 -12.8396",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.099 63.5357L-16.1211 -12.0233",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.843 64.3522L-17.377 -11.2051",
    stroke: "white",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.002 38.6982H81.6504L72.0805 23.1273L72.1422 22.9767L72.1456 22.9887L63.002 38.6982Z",
    fill: "#FF5A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5518 12.9991L83.7167 -0.000854492L106.93 38.9991H92.6002L76.5518 12.9991Z",
    fill: "#00109F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5518 12.9991L83.7167 -0.000854492L106.93 38.9991H92.6002L76.5518 12.9991Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4844 35.864H22.6093C23.2968 35.864 23.5858 35.5766 23.5858 34.8931V18.5182C23.5858 17.788 23.2889 17.5006 22.6093 17.5006H19.4844V14.3468H24.5155C26.617 14.3468 27.5466 15.3178 27.5466 17.454V35.9573C27.5466 38.0935 26.617 39.0644 24.5155 39.0644H19.4844V35.864Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00768 14.3468H0V45.4497H4.00768V14.3468Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0768 17.9906V39.0728H42.7567V35.8647H44.0769V19.0082C44.0769 17.9906 43.6395 17.408 42.9051 17.408C42.1239 17.408 41.6317 17.9906 41.6317 19.0082V39.0651H37.624V14.3474H41.6317V15.5592C42.2645 14.7358 43.1863 14.1998 44.4597 14.1998C46.5144 14.1998 48.0768 15.4116 48.0768 17.9906Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1169 17.9906V39.0728H11.7968V35.8647H13.117V19.0082C13.117 17.9906 12.6795 17.408 11.9452 17.408C11.164 17.408 10.6718 17.9906 10.6718 19.0082V39.0651H6.66406V14.3474H10.6718V15.5592C11.3046 14.7358 12.2342 14.1998 13.5076 14.1998C15.5545 14.1998 17.1169 15.4116 17.1169 17.9906Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5458 18.394V14.3469H30.5381V21.7109L34.5458 18.394Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5381 21.7815V28.8892H34.5067L34.5458 25.58H34.538L30.5381 21.7815Z",
    fill: "#969696"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMichman);
export default __webpack_public_path__ + "static/media/michman.05f2c7ea44c84515652001c9a53be65a.svg";
export { ForwardRef as ReactComponent };